// extracted by mini-css-extract-plugin
export default {"comingSoonContainer":"style_comingSoonContainer__cHyd1","highlight":"style_highlight__CSE92","notify":"style_notify__42mrY","callText":"style_callText__arTYj"};